import { Routes } from '@angular/router';

import { AuthGuard } from '../core/guards/auth.guard';
import { OrderErrorGuard } from '../core/guards/order-error.guard';
import { OrderErrorComponent } from '../pages/order-error/order-error.component';
import { OrderPartialErrorGuard } from '../core/guards/order-partial-error.guard';
import { OrderPartialErrorComponent } from '../pages/order-partial-error/order-partial-error.component';
import { OrderSuccessComponent } from '../pages/order-success/order-success.component';
import { OrderSuccessGuard } from '../core/guards/order-success.guard';
import { CheckoutComponent } from '../pages/checkout/checkout.component';

export const checkoutRoutes: Routes = [
  { path: 'checkout', component: CheckoutComponent, canActivate: [AuthGuard] },
  { path: 'order-success', component: OrderSuccessComponent, canActivate: [AuthGuard, OrderSuccessGuard] },
  { path: 'order-error', component: OrderErrorComponent, canActivate: [AuthGuard, OrderErrorGuard] },
  {
    path: 'order-partial-error',
    component: OrderPartialErrorComponent,
    canActivate: [AuthGuard, OrderPartialErrorGuard],
  },
];
